// extracted by mini-css-extract-plugin
export var addButton = "_5l-d";
export var bullets = "_5l-e";
export var compact = "_5l-2";
export var container = "_5l-j";
export var extendedWarrantyModal = "_5l-f";
export var learn = "_5l-l";
export var learnMore = "_5l-g";
export var offeringOption = "_5l-3";
export var offeringPrice = "_5l-8";
export var offeringSubtitle = "_5l-7";
export var offeringTitle = "_5l-6";
export var offeringsContainer = "_5l-0";
export var pdpTilesBackground = "_5l-n";
export var plan = "_5l-m";
export var regular = "_5l-1";
export var remove = "_5l-k";
export var seeDetailsIcon = "_5l-i";
export var seeDetailsLink = "_5l-h";
export var selectedOption = "_5l-4";
export var shieldIcon = "_5l-b";
export var shieldIconCompact = "_5l-c";
export var subtitle = "_5l-a";
export var title = "_5l-9";
export var unselectedOption = "_5l-5";